import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Client-side mirror of server pricing rules (for display only)
export const LOGO_SURCHARGE = 8.0;
export const EXTRA_LINE_SURCHARGE = 3.0;

export function computeUnitPrice(basePrice, customization = {}) {
  let price = Number(basePrice);
  if (customization.has_logo) price += LOGO_SURCHARGE;
  const lines = (customization.text_lines || []).filter((l) => String(l).trim());
  if (lines.length > 1) price += EXTRA_LINE_SURCHARGE * (lines.length - 1);
  return Math.round(price * 100) / 100;
}

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
